import React, { useState } from 'react'
import { Grid, Table, ButtonGroup, Checkbox } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import TooltipButton from '../../components/buttons/TooltipButton'

export default function DolMultimediaTable(props) {
  const { Column, HeaderCell, Cell, Pagination } = Table
  const {
    datas,
    disabled,
    checkedKeys,
    setCheckedKeys,
    onDownload,
    onDelete,
    isLoading,
    editMode,
  } = props
  const [page, setPage] = useState(1)
  const [displayLength, setDisplayLength] = useState(5)

  const [checkedAll, setCheckedAll] = useState(false)
  const [indeterminate, setIndeterminate] = useState(false)

  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
    { value: 20, label: 20 },
  ]

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
  }

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
  }

  const handleCheckAll = (value, checked) => {
    console.log('value : ', value, ', checked: ', checked)
    const keys = checked ? datas?.map((item) => item.refId) : []

    setCheckedAll(checked)
    setIndeterminate(false)
    setCheckedKeys(keys)
  }

  const handleCheck = (value, checked) => {
    const keys = checked ? [...checkedKeys, value] : checkedKeys.filter((item) => item !== value)

    if (keys.length === 0) {
      setCheckedAll(false)
    } else if (keys.length > 0 && keys.length < datas?.length) {
      setIndeterminate(true)
    }

    setCheckedKeys(keys)
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <div style={{ lineHeight: '46px' }}>
        <Checkbox
          value={rowData[dataKey]}
          disabled={disabled}
          inline
          onChange={onChange}
          checked={checkedKeys.some((item) => item === rowData[dataKey])}
        />
      </div>
    </Cell>
  )

  const getData = (fileItems) => {
    return fileItems?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  return (
    <Grid fluid>
      <Table
        wordWrap
        height={editMode ? 410 : 330}
        loading={isLoading}
        data={getData(datas) || []}
        cellBordered
      >
        {editMode && (
          <Column width={50} align="center">
            <HeaderCell style={{ padding: 0 }}>
              <div style={{ lineHeight: '40px' }}>
                <Checkbox
                  disabled={disabled}
                  inline
                  checked={checkedAll}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </div>
            </HeaderCell>
            <CheckCell dataKey="refId" checkedKeys={checkedKeys} onChange={handleCheck} />
          </Column>
        )}

        <Column width={80} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1 + displayLength * (page - 1)
            }}
          </Cell>
        </Column>

        <Column width={700} flexGrow={1}>
          <HeaderCell>ชื่อ</HeaderCell>
          {/* <Cell dataKey="description" /> */}
          <Cell dataKey="label" />
        </Column>

        <Column width={180} align="center">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <ButtonGroup>
                  <TooltipButton
                    isStart={true}
                    icon="eye"
                    tooltip={`แสดง`}
                    disabled={isLoading}
                    onClick={() => window.open(`${rowData.url}`, '_blank')}
                  />
                  <TooltipButton
                    isStart={false}
                    icon="download"
                    tooltip={`ดาวน์โหลด`}
                    disabled={isLoading}
                    onClick={(e) => onDownload(rowData)}
                  />
                  {!editMode && (
                    <TooltipButton
                      isStart={false}
                      icon="trash-o"
                      tooltip={`ลบ`}
                      disabled={isLoading}
                      onClick={(e) => onDelete(rowData)}
                    />
                  )}
                </ButtonGroup>
              )
            }}
          </Cell>
        </Column>
      </Table>
      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={datas?.length || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </Grid>
  )
}
